// extracted by extract-css-chunks-webpack-plugin
module.exports = {"games":"games_1TYUF","swiper":"swiper_3l6IM","navigation":"navigation_1rQ4o","prev":"prev_yMg-K","next":"next_3cqc2"};